/* Turns the raw OCR text of a visiting card into party details. Pure function - no DOM.
   Works on lines of text (one line of the card per line) in reading order. */

const STATES = [
  'Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chhattisgarh', 'Goa', 'Gujarat', 'Haryana',
  'Himachal Pradesh', 'Jharkhand', 'Karnataka', 'Kerala', 'Madhya Pradesh', 'Maharashtra', 'Manipur',
  'Meghalaya', 'Mizoram', 'Nagaland', 'Odisha', 'Punjab', 'Rajasthan', 'Sikkim', 'Tamil Nadu', 'Telangana',
  'Tripura', 'Uttar Pradesh', 'Uttarakhand', 'West Bengal', 'Delhi', 'Jammu and Kashmir', 'Ladakh',
  'Chandigarh', 'Puducherry',
];

const STATE_ALIASES = {
  orissa: 'Odisha', chattisgarh: 'Chhattisgarh', chhatisgarh: 'Chhattisgarh', tamilnadu: 'Tamil Nadu',
  'new delhi': 'Delhi', 'j and k': 'Jammu and Kashmir', uttaranchal: 'Uttarakhand', pondicherry: 'Puducherry',
  gujrat: 'Gujarat', guj: 'Gujarat', maharastra: 'Maharashtra', rajsthan: 'Rajasthan', 'u p': 'Uttar Pradesh',
  'm p': 'Madhya Pradesh', mp: 'Madhya Pradesh', up: 'Uttar Pradesh', raj: 'Rajasthan', mah: 'Maharashtra',
  'w b': 'West Bengal', bengal: 'West Bengal', 'a p': 'Andhra Pradesh', tn: 'Tamil Nadu',
};

/* First digits of the PIN code -> state, only where one state clearly owns the range. */
const PIN_PREFIX_STATE = [
  [['11'], 'Delhi'], [['12', '13'], 'Haryana'], [['14', '15'], 'Punjab'], [['17'], 'Himachal Pradesh'],
  [['30', '31', '32', '33', '34'], 'Rajasthan'], [['36', '37', '38', '39'], 'Gujarat'],
  [['40', '41', '42', '43', '44'], 'Maharashtra'], [['45', '46', '47', '48'], 'Madhya Pradesh'],
  [['49'], 'Chhattisgarh'], [['56', '57', '58', '59'], 'Karnataka'], [['60', '61', '62', '63', '64'], 'Tamil Nadu'],
  [['67', '68', '69'], 'Kerala'], [['70', '71', '72', '73', '74'], 'West Bengal'],
  [['75', '76', '77'], 'Odisha'], [['78'], 'Assam'],
];

/* Known towns (tile hubs first). City -> state is also used when the card has no state. */
const CITY_STATE = {
  Gujarat: ['Morbi', 'Wankaner', 'Halvad', 'Thangadh', 'Himmatnagar', 'Himatnagar', 'Rajkot', 'Ahmedabad', 'Surat', 'Vadodara', 'Baroda', 'Gandhinagar', 'Jamnagar', 'Bhavnagar', 'Surendranagar', 'Mehsana', 'Bhuj', 'Gandhidham', 'Anand', 'Navsari', 'Valsad', 'Vapi', 'Bharuch', 'Junagadh', 'Porbandar', 'Amreli', 'Palanpur', 'Deesa', 'Godhra', 'Kalol', 'Kadi', 'Sanand', 'Gondal', 'Jetpur', 'Dhrangadhra', 'Patan', 'Nadiad', 'Ankleshwar', 'Veraval', 'Botad', 'Visnagar', 'Unjha', 'Modasa', 'Himmatnagar'],
  Maharashtra: ['Mumbai', 'Pune', 'Thane', 'Nagpur', 'Nashik', 'Aurangabad', 'Kolhapur', 'Solapur', 'Navi Mumbai', 'Bhiwandi', 'Vasai', 'Amravati', 'Nanded', 'Sangli', 'Jalgaon', 'Akola'],
  Rajasthan: ['Jaipur', 'Jodhpur', 'Udaipur', 'Kota', 'Ajmer', 'Bikaner', 'Alwar', 'Bhilwara', 'Sikar', 'Kishangarh', 'Bhiwadi', 'Pali', 'Sri Ganganagar', 'Abu Road'],
  'Madhya Pradesh': ['Indore', 'Bhopal', 'Gwalior', 'Jabalpur', 'Ujjain', 'Ratlam', 'Sagar', 'Satna', 'Rewa'],
  Chhattisgarh: ['Raipur', 'Bhilai', 'Bilaspur', 'Durg', 'Korba'],
  Karnataka: ['Bengaluru', 'Bangalore', 'Mysuru', 'Mysore', 'Hubli', 'Mangaluru', 'Mangalore', 'Belgaum', 'Belagavi', 'Davangere', 'Tumkur'],
  'Tamil Nadu': ['Chennai', 'Coimbatore', 'Madurai', 'Salem', 'Trichy', 'Tiruchirappalli', 'Tirunelveli', 'Erode', 'Vellore', 'Tiruppur'],
  Telangana: ['Hyderabad', 'Secunderabad', 'Warangal', 'Karimnagar', 'Nizamabad'],
  'Andhra Pradesh': ['Visakhapatnam', 'Vijayawada', 'Guntur', 'Nellore', 'Tirupati', 'Kakinada', 'Rajahmundry'],
  Kerala: ['Kochi', 'Cochin', 'Thiruvananthapuram', 'Kozhikode', 'Thrissur', 'Kollam', 'Kannur', 'Palakkad'],
  'West Bengal': ['Kolkata', 'Howrah', 'Siliguri', 'Durgapur', 'Asansol'],
  'Uttar Pradesh': ['Lucknow', 'Kanpur', 'Agra', 'Varanasi', 'Meerut', 'Noida', 'Ghaziabad', 'Allahabad', 'Prayagraj', 'Bareilly', 'Aligarh', 'Moradabad', 'Gorakhpur', 'Mathura'],
  Bihar: ['Patna', 'Gaya', 'Muzaffarpur', 'Bhagalpur'],
  Punjab: ['Ludhiana', 'Amritsar', 'Jalandhar', 'Patiala', 'Bathinda', 'Mohali'],
  Haryana: ['Gurgaon', 'Gurugram', 'Faridabad', 'Panipat', 'Ambala', 'Karnal', 'Hisar', 'Rohtak', 'Sonipat'],
  Delhi: ['Delhi', 'New Delhi'],
  Chandigarh: ['Chandigarh'],
  Assam: ['Guwahati'],
  Odisha: ['Bhubaneswar', 'Cuttack', 'Rourkela'],
  Jharkhand: ['Ranchi', 'Jamshedpur', 'Dhanbad'],
  Uttarakhand: ['Dehradun', 'Haridwar', 'Roorkee'],
  Goa: ['Panaji', 'Margao'],
};
const CITY_TO_STATE = {};
Object.keys(CITY_STATE).forEach((st) => CITY_STATE[st].forEach((c) => { CITY_TO_STATE[c.toLowerCase()] = st; }));
const KNOWN_CITIES = Object.keys(CITY_TO_STATE).sort((a, b) => b.length - a.length);

const BUSINESS_WORDS = /\b(pvt|private|ltd|limited|llp|tiles|tile|ceramic|ceramics|traders|trading|trade|enterprise|enterprises|industries|industry|industrial|agency|agencies|corporation|corp|company|co|group|marketing|distributors|distributor|sales|stores|store|mart|exports|export|imports|import|sanitary|sanitaryware|hardware|decor|marble|marbles|granite|granites|vitrified|solutions|infra|infrastructure|builders|developers|constructions|construction|furniture|associates|brothers|bros|impex|exim|international|overseas|ventures|engineers|engineering|minerals|mills|products|exporters|importers|tradelink|tradex|agro|materials|material|interiors|interior|polymers|plastics|paints|electricals|electric|lighting|glass|abrasives|abrasive|enterprize|emporium|centre|center|house|works|suppliers|supplier|merchants|collection|creations|gallery|showroom|studio|tech|technologies|systems|services|logistics|transport|roadways|carriers|metals|steel|cement|bricks|stone|stones|surfaces)\b/i;
const ADDRESS_WORDS = /\b(road|rd|street|st|nagar|plot|floor|flr|near|opp|opposite|society|shop|gidc|highway|hwy|complex|bldg|market|chowk|circle|area|park|sector|phase|tower|village|vill|taluka|tal|dist|district|colony|estate|bypass|crossing|flat|office|behind|ground|first|second|third|survey|gat|lane|cross|main|block|ward|marg|path|bazar|bazaar|mandal|apartment|apt|residency|chambers|plaza|arcade|godown|warehouse|no)\b/i;
const TAGLINE = /\b(authori[sz]ed|dealers?\s+(in|of)|distributors?\s+(of|for)|stockist|deals?\s+in|dealing\s+in|agent\s+for|sole\s+(selling|distributor)|supplier\s+of|suppliers\s+of|manufacturers?\s+(of|&|and)|exporters?\s+(of|&|and)|importers?\s+(of|&|and)|wholesale|our\s+brands?|since\s+\d{4}|estd\.?\s*\d{4}|est\.?\s*\d{4}|all\s+types|all\s+kinds|specialist|specialists|quality|trusted|your\s+trusted)\b/i;
const SIZE_LINE = /\b\d{3,4}\s*[xX×]\s*\d{3,4}\s*(mm)?\b/;
const ID_LINE = /\b(gstin|gst\s*no|gst|fssai|pan|cin|udyam|iec|reg\.?\s*no|tin|vat)\b\s*[:.-]?\s*[A-Z0-9]{6,}/i;
const WEB_MAIL = /(www\.|https?:|\.com\b|\.co\.in\b|\.in\b|\.net\b|\.org\b|@)/i;
const ROLE_WORDS = '(?:managing\\s+director|executive\\s+director|director|proprietor|proprietress|prop|partner|owner|founder|co[- ]?founder|ceo|chairman|president|general\\s+manager|sales\\s+manager|marketing\\s+manager|branch\\s+manager|area\\s+manager|manager|marketing\\s+head|sales\\s+head|marketing\\s+executive|sales\\s+executive|sr\\.?\\s*executive|senior\\s+executive|executive|sales\\s+officer|consultant|authori[sz]ed\\s+signatory|md|m\\.d)';
const ROLE_ONLY = new RegExp(`^\\(?\\s*${ROLE_WORDS}(?:\\s*(?:&|and|/)\\s*${ROLE_WORDS})?\\s*\\)?\\.?$`, 'i');
const ROLE_TRAIL = new RegExp(`^(.*?)[\\s,(\\-–:|]+\\(?\\s*(${ROLE_WORDS})\\s*\\)?\\.?$`, 'i');
const ROLE_LEAD = new RegExp(`^(?:${ROLE_WORDS})\\s*[.:\\-]+\\s*(.+)$`, 'i');
const NAME_LABEL = /^(?:contact\s+person|contact|name|person|prop(?:rietor)?|owner|director|partner)\s*[:.-]\s*(.+)$/i;
const TITLE_PREFIX = /^(mr|mrs|ms|miss|shri|shree|sri|smt|dr|er|ca|adv|prof)\.?\s+/i;
const LABEL_PREFIX = /^(?:mobile|mob|cell|phone|ph|tel|telephone|whatsapp|w\/a|wa|contact|call|off|office|res|fax|email|e-?mail|mail|web|website|add|address|addr|factory|works|regd\.?\s*office)\s*(?:no\.?)?\s*[.:-]\s*/i;

const norm = (s) => String(s || '').replace(/&/g, ' and ').replace(/[^A-Za-z0-9 ]+/g, ' ').replace(/\s+/g, ' ').trim().toLowerCase();
const titleCase = (s) => String(s).toLowerCase().replace(/\b[a-z]/g, (c) => c.toUpperCase());
function lev(a, b) {
  const m = a.length;
  const n = b.length;
  let prev = Array.from({ length: n + 1 }, (_, j) => j);
  for (let i = 1; i <= m; i += 1) {
    const cur = [i];
    for (let j = 1; j <= n; j += 1) cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
    prev = cur;
  }
  return prev[n];
}
const letters = (s) => s.replace(/[^A-Za-z]/g, '').length;
const digits = (s) => s.replace(/\D/g, '').length;

function cleanLine(line) {
  return String(line || '')
    .replace(/[|•·●❖★☆✆✉☎⚓⌂☏■▪►➜➤→]+/g, ' ')
    .replace(/[–—]/g, '-')
    .replace(/[‘’]/g, "'")
    .replace(/[“”]/g, '"')
    .replace(/[™®©]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

/* OCR often glues a logo letter / icon in front of a line ("s KERA VITRIFIED LLP", "@ Near Water Tank"). */
function stripJunkPrefix(line) {
  let t = line;
  for (let n = 0; n < 3; n += 1) {
    const tok = t.split(' ');
    if (tok.length < 3) break;
    const first = tok[0];
    const single = /^[A-Za-z=@&*#~]$/.test(first) && (tok.length >= 4 || first === first.toLowerCase() || /[=@&*#~]/.test(first));
    const mixed = /^\d[A-Za-z]{3,}$/.test(first) || /^[^A-Za-z0-9+(]+$/.test(first) || /^[A-Za-z]{1,2}[\])}>|]$/.test(first);
    if (!single && !mixed) break;
    t = tok.slice(1).join(' ');
  }
  return t.replace(/,\s+[A-Za-z0-9]$/, ',').replace(/[\s\-:;,.]+$/, (m) => (m.includes(',') && /,\s*$/.test(m) ? ',' : ''));
}

/** Pulls 10-digit Indian mobile numbers out of one phone-like run of digits and spaces. */
function mobilesInRun(run) {
  const tokens = run.split(/\s+/).map((t) => t.replace(/\D/g, '')).filter(Boolean);
  const out = [];
  let i = 0;
  while (i < tokens.length) {
    let acc = '';
    let j = i;
    while (j < tokens.length && acc.length < 10) {
      acc += tokens[j];
      j += 1;
    }
    let d = acc;
    if (d.length === 12 && d.startsWith('91')) d = d.slice(2);
    else if (d.length === 11 && d.startsWith('0')) d = d.slice(1);
    if (d.length === 10 && /^[6-9]/.test(d)) {
      out.push(d);
      i = j;
    } else {
      i += 1;
    }
  }
  return out;
}

/** OCR reads O/l/I/S/B inside phone numbers as letters. Only touches lines that are clearly phone lines. */
function fixPhoneLine(line) {
  if (digits(line) < 7 || letters(line.replace(/\b(mob|mobile|cell|phone|ph|tel|whatsapp|wa|off|res|fax|no|m|t|p)\b/gi, '')) > 4) return line;
  return line.replace(/[\dOoIl|SBZ+()-]{3,}/g, (tok) => (digits(tok) >= 2 ? tok.replace(/[OoIl|SBZ]/g, (c) => ({ O: '0', o: '0', I: '1', l: '1', '|': '1', S: '5', B: '8', Z: '2' }[c])) : tok));
}

function findMobiles(lines) {
  const found = [];
  lines.forEach((line, li) => {
    const fixed = fixPhoneLine(line);
    const runs = fixed.match(/\+?\d[\d\s.()-]{8,}\d/g) || [];
    runs.forEach((run) => {
      mobilesInRun(run).forEach((number) => {
        if (!found.some((f) => f.number === number)) found.push({ number, line: li });
      });
    });
  });
  return found;
}

/** OCR typos in a state name ("Gujrat", "Rajasthn"): compare word windows with an edit distance of 1-2. */
function fuzzyState(paddedNorm) {
  const words = paddedNorm.trim().split(' ');
  let best = null;
  STATES.forEach((st) => {
    const target = norm(st);
    const count = target.split(' ').length;
    if (target.length < 6) return;
    for (let i = 0; i + count <= words.length; i += 1) {
      const win = words.slice(i, i + count).join(' ');
      const d = lev(win, target);
      if (d <= (target.length >= 9 ? 2 : 1) && (!best || d < best.d)) best = { name: st, d };
    }
  });
  return best ? best.name : '';
}

function findState(text, pin) {
  const n = ` ${norm(text)} `;
  let best = null;
  STATES.forEach((st) => {
    const idx = n.indexOf(` ${norm(st)} `);
    if (idx >= 0 && (best === null || idx < best.idx)) best = { name: st, idx };
  });
  Object.keys(STATE_ALIASES).forEach((al) => {
    const idx = n.indexOf(` ${al} `);
    if (idx >= 0 && (best === null || idx < best.idx)) best = { name: STATE_ALIASES[al], idx };
  });
  if (best) return best.name;
  const fz = fuzzyState(n);
  if (fz) return fz;
  if (pin) {
    const hit = PIN_PREFIX_STATE.find(([prefixes]) => prefixes.includes(pin.slice(0, 2)));
    if (hit && pin.slice(0, 3) !== '403') return hit[1];
  }
  return '';
}

const LABEL_WORDS = /^(e-?mail|website|web|address|add|cell|mob|mobile|phone|ph|tel|telephone|email|e mail|fax|whatsapp|contact|pin|pincode|gst|india|bharat|no|dist|ta|tal)\.?:?$/i;

function cityParts(line, state) {
  let t = line.replace(/\b\d{3}\s?\d{3}\b/g, ' ').replace(/\(.*?\)/g, ' ');
  if (state) t = t.replace(new RegExp(`\\b${state.replace(/ /g, '\\s+')}\\b`, 'ig'), ' ');
  return t.split(/[,\-/]/)
    .map((p) => p.replace(/\b(india|bharat|dist|district|ta|tal|taluka|pin|pincode|pin code)\b\.?:?/gi, ' ').replace(/[^A-Za-z .]/g, ' ').replace(/\s+/g, ' ').trim())
    .filter((p) => p.length >= 3 && !ADDRESS_WORDS.test(p) && !LABEL_WORDS.test(p));
}

/** Known town in the text; the right-most one wins (the town sits right before the PIN / state). */
function knownCityIn(text, beforePin) {
  let t = String(text || '');
  if (beforePin) {
    const at = t.replace(/\s/g, '').indexOf(beforePin);
    if (at >= 0) {
      const m = t.match(new RegExp(beforePin.split('').join('\\s?')));
      if (m && m.index > 0) t = t.slice(0, m.index);
    }
  }
  const n = ` ${norm(t)} `;
  let best = null;
  KNOWN_CITIES.forEach((k) => {
    const idx = n.lastIndexOf(` ${k} `);
    if (idx >= 0 && (best === null || idx > best.idx || (idx === best.idx && k.length > best.k.length))) best = { k, idx };
  });
  return best ? titleCase(best.k) : '';
}

function fixCity(c) {
  if (!c) return c;
  const key = c.toLowerCase();
  if (CITY_TO_STATE[key] || key.length < 6) return c;
  let best = null;
  KNOWN_CITIES.forEach((k) => {
    if (Math.abs(k.length - key.length) > 1) return;
    const d = lev(k, key);
    if (d <= (key.length >= 9 ? 2 : 1) && (!best || d < best.d)) best = { k, d };
  });
  return best ? titleCase(best.k) : c;
}

function findCityRaw(lines, pin, state) {
  if (state === 'Delhi' || state === 'Chandigarh') return state;
  const pinLine = pin ? lines.findIndex((l) => l.replace(/\s/g, '').includes(pin)) : -1;
  const stateLine = state ? lines.findIndex((l) => norm(l).includes(norm(state))) : -1;
  const zone = [pinLine, stateLine].filter((i) => i >= 0);
  /* a known town in the pin / state line (or the line before it) is the safest answer */
  for (let z = 0; z < zone.length; z += 1) {
    const idx = zone[z];
    const parts = cityParts(lines[idx], state);
    const hit = knownCityIn(lines[idx], pin);
    if (hit) return hit;
    if (parts.length > 0) return titleCase(parts[parts.length - 1]);
    const prev = idx > 0 ? knownCityIn(lines[idx - 1]) : '';
    if (prev) return prev;
  }
  const distLine = lines.map((l) => l.match(/\b(?:dist|district)\.?\s*[:-]?\s*([A-Za-z]{3,}(?: [A-Za-z]{3,})?)/i)).find(Boolean);
  if (distLine) return titleCase(distLine[1]);
  const any = knownCityIn(lines.join(' '));
  if (any) return any;
  for (let z = 0; z < zone.length; z += 1) {
    const idx = zone[z];
    if (idx > 0) {
      const prev = cityParts(lines[idx - 1], state);
      const last = prev[prev.length - 1];
      if (last && last.split(' ').length <= 2) return titleCase(last);
    }
  }
  return '';
}

function looksLikePerson(line) {
  const t = line.replace(TITLE_PREFIX, '').replace(/[\s,.\-:]+$/, '');
  if (!/^[A-Za-z.' ]+$/.test(t)) return false;
  const words = t.split(' ').filter(Boolean);
  if (words.length < 2 || words.length > 4) return false;
  if (BUSINESS_WORDS.test(t) || ADDRESS_WORDS.test(t) || TAGLINE.test(t)) return false;
  if (ROLE_ONLY.test(t)) return false;
  return words.every((w) => w.length >= 2 || /\./.test(w) || /^[A-Z]$/.test(w));
}

function stripLabel(line) {
  return line.replace(LABEL_PREFIX, '').trim();
}

/** "Hitesh Faldu Managing Director" / "Ramesh Sharma (Partner)" / "Prop. Mahesh Shah" -> { name, role } */
function splitNameRole(line) {
  const lab = line.match(NAME_LABEL);
  if (lab) return { name: lab[1].replace(/[\s,.\-:]+$/, ''), role: true };
  const lead = line.match(ROLE_LEAD);
  if (lead && lead[1]) return { name: lead[1].replace(/[\s,.\-:]+$/, ''), role: true };
  const trail = line.match(ROLE_TRAIL);
  if (trail && trail[1] && trail[1].trim().length >= 3) return { name: trail[1].replace(/[\s,.\-:]+$/, ''), role: true };
  return { name: line.replace(/[\s,.\-:]+$/, ''), role: false };
}

/**
 * @param {string} rawText OCR text
 * @param {{ignore?: string[]}} [opts] ignore: brand / logo lines to skip when choosing the party name (any case)
 */
function findCity(lines, pin, state) {
  return fixCity(findCityRaw(lines, pin, state));
}

export function parseCard(input, opts = {}) {
  const ignore = (opts.ignore || []).map((t) => norm(t)).filter(Boolean);
  /* input: raw text, or [{ t: line text, h: line height in px }] from the OCR (heights break ties between firm and tagline) */
  const entries = (Array.isArray(input) ? input : String(input || '').split(/\r?\n/).map((t) => ({ t, h: 0 })))
    .map((e) => ({ t: stripJunkPrefix(cleanLine(e.t)), h: Number(e.h) || 0 }))
    .filter((e) => e.t.replace(/[^A-Za-z0-9]/g, '').length >= 2);
  const lines = entries.map((e) => e.t);
  const heights = entries.map((e) => e.h);
  const text = lines.join('\n');

  const mobiles = findMobiles(lines);
  const labelled = mobiles.find((m) => /\b(mob|mobile|cell|m|mo|wa|whatsapp|ph|phone|contact)\b[\s.:-]/i.test(`${lines[m.line]} `) || /\+\s*91/.test(lines[m.line]));
  const mobile = (labelled || mobiles[0] || { number: '' }).number;

  const emailMatch = text.match(/[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}/);
  const email = emailMatch ? emailMatch[0] : '';

  const noPhone = lines.map((l) => fixPhoneLine(l).replace(/\+?\d[\d\s.()-]{8,}\d/g, ' '));
  const pinMatch = noPhone.join('\n').match(/(?:^|[^\d])([1-9]\d{2}\s?\d{3})(?!\d)/);
  const pincode = pinMatch ? pinMatch[1].replace(/\s/g, '') : '';

  let state = findState(noPhone.join('\n'), pincode);
  const city = findCity(noPhone, pincode, state);
  if (!state && city) state = CITY_TO_STATE[city.toLowerCase()] || '';

  /* ---- classify every line ---- */
  const phoneLine = (l) => digits(l) >= 8 && letters(l.replace(LABEL_PREFIX, '')) <= 12;
  const info = lines.map((l, i) => {
    const bare = stripLabel(l);
    const kind = { line: l, bare, i, type: '', h: heights[i] };
    if (phoneLine(l) || (mobiles.some((m) => m.line === i) && letters(bare) <= 8)) kind.type = 'phone';
    else if (WEB_MAIL.test(l) || ID_LINE.test(l)) kind.type = 'contact';
    else if (SIZE_LINE.test(l) || TAGLINE.test(l)) kind.type = 'tagline';
    else if (ignore.some((t) => norm(l).includes(t))) kind.type = 'ignored';
    else if (ROLE_ONLY.test(bare.replace(/[\s,.\-:]+$/, ''))) kind.type = 'role';
    else if (LABEL_WORDS.test(bare.replace(/[\s,.\-:]+$/, '')) || LABEL_WORDS.test(l.replace(/[\s,.\-:]+$/, '')) || /^e-?mail$/i.test(l.replace(/[\s,.\-:]+$/, ''))) kind.type = 'label';
    return kind;
  });
  const hasBiz = (s) => BUSINESS_WORDS.test(s);
  const addrLike = (s) => {
    if (pincode && s.replace(/\s/g, '').includes(pincode)) return true;
    if (/\b(india|bharat)\b/i.test(s) && /,/.test(s)) return true;
    if (ADDRESS_WORDS.test(s) && !(hasBiz(s) && digits(s) === 0 && !/,/.test(s))) return true;
    if (state && norm(s).includes(norm(state))) return true;
    if (city && norm(s).includes(norm(city)) && (/[,-]/.test(s) || digits(s) > 0)) return true;
    return /^\d+[\s,/-]/.test(s) || (/^[A-Z]?-?\d+[A-Za-z]?[\s,/-]/.test(s) && digits(s) > 0 && letters(s) > 6);
  };
  info.forEach((k) => { if (!k.type && addrLike(k.bare)) k.type = 'address'; });

  /* ---- person: name-like line next to the phone / a role line / with a role attached ---- */
  const cands = info.filter((k) => !k.type);
  const near = (i, test) => [info[i - 1], info[i + 1]].some((x) => x && test(x));
  const personOptions = cands.map((k) => {
    const sp = splitNameRole(k.bare);
    const name = sp.name.replace(TITLE_PREFIX, '').trim();
    let score = -99;
    if (looksLikePerson(name) && !(hasBiz(name) && !sp.role)) {
      score = 0;
      if (sp.role) score += 4;
      if (near(k.i, (x) => x.type === 'phone')) score += 3;
      if (near(k.i, (x) => x.type === 'role')) score += 4;
      if (TITLE_PREFIX.test(k.bare)) score += 2;
      if (/[a-z]/.test(name)) score += 2;
      if (/\b[A-Z]\./.test(name)) score += 1;
      if (hasBiz(name)) score -= 6;
      if (name.split(' ').length === 2) score += 1;
    }
    return { k, name, score };
  }).filter((p) => p.score > -50);
  let best = null;
  personOptions.forEach((p) => { if (!best || p.score > best.score || (p.score === best.score && p.k.i < best.k.i)) best = p; });
  const person = best ? titleCase(best.name) : '';
  const personIdx = best ? best.k.i : -1;

  /* ---- firm: business word, right above the address, not a one-word logo ---- */
  const firstAddr = info.findIndex((k) => k.type === 'address');
  const firmCands = cands.filter((k) => k.i !== personIdx);
  const above = firstAddr >= 0 ? firmCands.filter((k) => k.i < firstAddr) : [];
  const firmScore = (k) => {
    const s = k.bare.replace(/^m\/?s\.?\s+/i, '');
    let sc = 0;
    if (hasBiz(s)) sc += 6 + Math.min(2, (s.match(BUSINESS_WORDS) || []).length - 1);
    if (/^m\/?s\.?\s+/i.test(k.bare)) sc += 4;
    if (above.length && above[above.length - 1].i === k.i) sc += 3;
    else if (above.length > 1 && above[above.length - 2].i === k.i) sc += 1;
    if (s.split(' ').length === 1) sc -= 2;
    if (letters(s) < 4) sc -= 3;
    if (s.length > 48) sc -= 2;
    if (!/[A-Za-z]{3}/.test(s)) sc -= 5;
    if (looksLikePerson(s) && !hasBiz(s)) sc -= 1;
    return sc;
  };
  let bestF = null;
  firmCands.forEach((k) => {
    const sc = firmScore(k);
    if (!bestF || sc > bestF.sc || (sc === bestF.sc && (k.h > bestF.k.h * 1.15 || (k.h >= bestF.k.h * 0.87 && k.i > bestF.k.i)))) bestF = { k, sc };
  });
  const firmLine = bestF ? bestF.k : null;
  const company = firmLine ? firmLine.bare.replace(/^m\/?s\.?\s+/i, '').replace(/[\s,.\-:]+$/, '') : '';

  /* ---- address ---- */
  const addressLines = [];
  info.filter((k) => k.type === 'address').map((k) => k.bare.replace(/[\s,]+$/, '')).forEach((line) => {
    /* the same line read twice (once with a stray logo word in front) - keep the cleaner one */
    const n = norm(line);
    const wc = (x) => x.split(' ').length;
    const at = addressLines.findIndex((b) => {
      const m = norm(b);
      return m === n || (n.endsWith(` ${m}`) && wc(n) - wc(m) <= 1) || (m.endsWith(` ${n}`) && wc(m) - wc(n) <= 1);
    });
    if (at < 0) addressLines.push(line);
    else if (line.length < addressLines[at].length) addressLines[at] = line;
  });
  const address = addressLines.join(', ').replace(/\s*,\s*,/g, ',').slice(0, 255);

  const candidates = firmCands.slice().sort((a, b) => firmScore(b) - firmScore(a)).map((k) => k.bare.replace(/^m\/?s\.?\s+/i, ''))
    .concat(person ? [best.name] : []).filter((l, i, arr) => l.length >= 3 && l.length <= 60 && !/\d/.test(l) && arr.indexOf(l) === i).slice(0, 8);

  const name = company ? (person ? `${company} (${person})` : company) : person;
  return {
    customer_name: name, contact_person: person, company, candidates,
    customer_mobile: mobile, customer_address: address, customer_city: city, customer_state: state, email, pincode,
  };
}

/** True when a line has a firm-type word (Traders, Tiles, Impex, Pvt Ltd ...). */
export function hasBusinessWord(line) {
  return BUSINESS_WORDS.test(String(line || ''));
}

/** wa.me wants country code + number without + or spaces; bare 10 digit numbers are Indian. */
export function whatsappNumber(raw) {
  let d = String(raw || '').replace(/\D/g, '');
  if (d.length === 11 && d.startsWith('0')) d = d.slice(1);
  if (d.length === 10) d = `91${d}`;
  return d.length >= 11 && d.length <= 15 ? d : '';
}
